import React from 'react'

import Script from 'dangerous-html/react'

import './navigation.css'
import logo from './assets/main_logo.jpg'

const Navigation = (props) => {
  return (
    <div className="navigation-container1">
      <div className="navigation-container2">
        <div className="navigation-container3">
          <Script
            html={`<style>
        @keyframes techScanline {0%,100% {opacity: 0;}
50% {opacity: 0.6;}}@keyframes techBarSlide {0% {left: -100%;}
100% {left: 100%;}}
        </style> `}
          ></Script>
        </div>
      </div>
      <div className="navigation-container4">
        <div className="navigation-container5">
          <Script
            html={`<style>
@media (prefers-reduced-motion: reduce) {
.navigation, .navigation__link, .navigation__mode, .navigation__mobile-link, .navigation__mobile-close, .navigation__toggle {
  transition: none;
}
.navigation::before, .navigation__tech-bar::before {
  animation: none;
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div className="navigation-container6">
        <div className="navigation-container7">
          <Script
            html={`<script defer data-name="navigation">
(function(){
  const navToggle = document.getElementById("navToggle")
  const mobileMenu = document.getElementById("mobileMenu")
  const mobileClose = document.getElementById("mobileClose")
  const mobileBackdrop = mobileMenu.querySelector(
    ".navigation__mobile-backdrop"
  )
  const mobileLinks = mobileMenu.querySelectorAll(".navigation__mobile-link")

  function openMobileMenu() {
    mobileMenu.classList.add("navigation__mobile-menu--active")
    navToggle.setAttribute("aria-expanded", "true")
    document.body.style.overflow = "hidden"
  }

  function closeMobileMenu() {
    mobileMenu.classList.remove("navigation__mobile-menu--active")
    navToggle.setAttribute("aria-expanded", "false")
    document.body.style.overflow = ""
  }

  navToggle.addEventListener("click", openMobileMenu)
  mobileClose.addEventListener("click", closeMobileMenu)
  mobileBackdrop.addEventListener("click", closeMobileMenu)

  mobileLinks.forEach((link) => {
    link.addEventListener("click", closeMobileMenu)
  })

  document.addEventListener("keydown", (e) => {
    if (
      e.key === "Escape" &&
      mobileMenu.classList.contains("navigation__mobile-menu--active")
    ) {
      closeMobileMenu()
    }
  })

  const nav = document.getElementById("mainNav")
  let lastScrollY = window.scrollY

  window.addEventListener("scroll", () => {
    const currentScrollY = window.scrollY

    if (currentScrollY > 100) {
      nav.style.boxShadow = "var(--shadow-level-3)"
    } else {
      nav.style.boxShadow = "none"
    }

    lastScrollY = currentScrollY
  })
})()
</script>`}
          ></Script>
        </div>
      </div>
      <nav id="mainNav" className="navigation">
        <div className="navigation__container">
          <a href="/" id="navLogo">
            <div aria-label="ZNY Logistics Home" className="navigation__logo">
              {/* <div className="navigation__logo-mark"> */}
              <div className="navigation__logo ">
                <img className="background_blue "src={logo} width={54} height={54}  />
              </div>
              <div className="navigation__logo-text">
                <span className="navigation__logo-company">ATLAS WAY</span>
                <span className="navigation__logo-tagline">Global</span>
              </div>
            </div>
          </a>
          <div id="navLinks" className="navigation__links">
            <a href="#services">
              <div className="navigation__link">
                <span className="navigation__link-text">Services</span>
                <span className="navigation__link-bar"></span>
              </div>
            </a>
            <a href="#about">
              <div className="navigation__link">
                <span className="navigation__link-text">About</span>
                <span className="navigation__link-bar"></span>
              </div>
            </a>
            <a href="#tracking">
              <div className="navigation__link">
                <span className="navigation__link-text">Tracking</span>
                <span className="navigation__link-bar"></span>
              </div>
            </a>
            <a href="#solutions">
              <div className="navigation__link">
                <span className="navigation__link-text">Solutions</span>
                <span className="navigation__link-bar"></span>
              </div>
            </a>
            <a href="#contact">
              <div className="navigation__link">
                <span className="navigation__link-text">Contact</span>
                <span className="navigation__link-bar"></span>
              </div>
            </a>
          </div>
          <div className="navigation__modes">
            <div title="Air Freight" className="navigation__mode">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8L4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1l3 2l2 3l1-1v-3l3-2l3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2"
                ></path>
              </svg>
            </div>
            <div title="Sea Freight" className="navigation__mode">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                >
                  <path d="M12 10.189V14m0-12v3m7 8V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"></path>
                  <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"></path>
                  <path d="M2 21c.6.5 1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1"></path>
                </g>
              </svg>
            </div>
            <div title="Rail Freight" className="navigation__mode">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                >
                  <rect width="16" height="16" x="4" y="3" rx="2"></rect>
                  <path d="M4 11h16m-8-8v8m-4 8l-2 3m12 0l-2-3m-8-4h.01M16 15h.01"></path>
                </g>
              </svg>
            </div>
            <div title="Road Freight" className="navigation__mode">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                >
                  <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                  <circle cx="17" cy="18" r="2"></circle>
                  <circle cx="7" cy="18" r="2"></circle>
                </g>
              </svg>
            </div>
          </div>
          <button className="navigation__cta btn btn-accent">
            Request Quote
          </button>
          <button
            id="navToggle"
            aria-label="Toggle navigation menu"
            aria-expanded="false"
            className="navigation__toggle"
          >
            <span
              id="navToggleIcon"
              className="navigation-navigationtoggle-icon"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 5h16M4 12h16M4 19h16"
                ></path>
              </svg>
            </span>
          </button>
        </div>
        <div id="mobileMenu" className="navigation__mobile-menu">
          <div className="navigation__mobile-backdrop"></div>
          <div className="navigation__mobile-content">
            <div className="navigation__mobile-header">
              <div className="navigation__mobile-logo">
                <span className="navigation__logo-company">ATLAS</span>
                <span className="navigation__logo-tagline">WAY GLOBAL</span>
              </div>
              <button
                id="mobileClose"
                aria-label="Close menu"
                className="navigation__mobile-close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M18 6L6 18M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
            <nav className="navigation__mobile-links">
              <a href="#services">
                <div className="navigation__mobile-link">
                  <span>Services</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 6l6 6l-6 6"
                    ></path>
                  </svg>
                </div>
              </a>
              <a href="#about">
                <div className="navigation__mobile-link">
                  <span>About</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 6l6 6l-6 6"
                    ></path>
                  </svg>
                </div>
              </a>
              <a href="#tracking">
                <div className="navigation__mobile-link">
                  <span>Tracking</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 6l6 6l-6 6"
                    ></path>
                  </svg>
                </div>
              </a>
              <a href="#solutions">
                <div className="navigation__mobile-link">
                  <span>Solutions</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 6l6 6l-6 6"
                    ></path>
                  </svg>
                </div>
              </a>
              <a href="#contact">
                <div className="navigation__mobile-link">
                  <span>Contact</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9 6l6 6l-6 6"
                    ></path>
                  </svg>
                </div>
              </a>
            </nav>
            <div className="navigation__mobile-footer">
              <button className="navigation__mobile-cta btn btn-accent">
                {' '}
                Request Quote
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </button>
              <div className="navigation__mobile-modes">
                <span>Transport Modes:</span>
                <div className="navigation__mobile-modes-grid">
                  <div className="navigation__mobile-mode">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M17.8 19.2L16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8L4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1l3 2l2 3l1-1v-3l3-2l3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2"
                      ></path>
                    </svg>
                    <span>Air</span>
                  </div>
                  <div className="navigation__mobile-mode">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M12 10.189V14m0-12v3m7 8V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"></path>
                        <path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"></path>
                        <path d="M2 21c.6.5 1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2c1.3 0 1.9.5 2.5 1"></path>
                      </g>
                    </svg>
                    <span>Sea</span>
                  </div>
                  <div className="navigation__mobile-mode">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <rect width="16" height="16" x="4" y="3" rx="2"></rect>
                        <path d="M4 11h16m-8-8v8m-4 8l-2 3m12 0l-2-3m-8-4h.01M16 15h.01"></path>
                      </g>
                    </svg>
                    <span>Rail</span>
                  </div>
                  <div className="navigation__mobile-mode">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                      >
                        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2m10 0H9m10 0h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path>
                        <circle cx="17" cy="18" r="2"></circle>
                        <circle cx="7" cy="18" r="2"></circle>
                      </g>
                    </svg>
                    <span>Road</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="navigation__tech-bar"></div>
      </nav>
    </div>
  )
}

export default Navigation
